import React, { useState, useEffect } from 'react';
import { updateUserProfile, getUserProfile } from '../services/userService';
import TermsAndConditionsModal from './TermsAndConditionsModal';

const ProfileCompletionModal = ({ user, onComplete, checkTerms = false, onTermsAccept }) => {
  const [displayName, setDisplayName] = useState('');
  const [notificationEmail, setNotificationEmail] = useState(user.email || '');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [showTerms, setShowTerms] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);

  useEffect(() => {
    const checkTermsAcceptance = async () => {
      if (checkTerms) {
        const profile = await getUserProfile(user.uid);
        if (!profile?.termsAccepted) {
          setShowTerms(true);
        }
      }
    };

    checkTermsAcceptance();
  }, [user.uid, checkTerms]);

  const handleTermsAccept = async () => {
    try {
      await onTermsAccept();
      setTermsAccepted(true);
      setShowTerms(false);
    } catch (error) {
      console.error('Error accepting terms:', error);
      setError('Failed to accept terms. Please try again.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      await updateUserProfile(user.uid, {
        displayName,
        notificationEmail
      });
      onComplete();
    } catch (err) {
      setError('Failed to update profile. Please try again.');
      console.error('Profile update error:', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (showTerms) {
    return <TermsAndConditionsModal onAccept={handleTermsAccept} />;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <h2 className="text-xl font-semibold mb-4">Complete Your Profile</h2>
        <p className="text-gray-600 mb-4">
          Please provide your name and email for notifications.
        </p>
        
        {error && (
          <div className="mb-4 p-3 bg-red-100 text-red-700 rounded">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Display Name
            </label>
            <input
              type="text"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded"
              required
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Notification Email
            </label>
            <input
              type="email"
              value={notificationEmail}
              onChange={(e) => setNotificationEmail(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded"
              required
            />
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-[#04b53a] text-white py-2 rounded hover:bg-[#039431] disabled:opacity-50"
          >
            {isSubmitting ? 'Saving...' : 'Save Profile'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ProfileCompletionModal;